import {
  Component,
  ElementRef,
  inject,
  input,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { SettingsService } from '../../../core/settings/settings.service';
import { MsisdnInputDirective } from '@app/shared/directives/msisdn-input.directive';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { AppFocusableDirective } from '@app/shared/directives/focusable.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { MsisdnInputIdService } from '@app/shared/services/msisdn-input-id.service';

@Component({
  selector: 'app-msisdn-input',
  templateUrl: './msisdn-input.component.html',
  styleUrl: './msisdn-input.component.scss',
  imports: [
    MsisdnInputDirective,
    ReactiveFormsModule,
    InputErrorsComponent,
    AppFocusableDirective,
    TranslatePipe,
  ],
  host: {
    '[id]': `wrapperId()`,
  },
})
export class MsisdnInputComponent {
  @ViewChild('input') public input!: ElementRef;
  public readonly passedFormControl = input<UntypedFormControl>(undefined!);
  public readonly showLabel = input(true);
  public readonly showErrors = input(false);
  public readonly readonly = input(false);
  public readonly required = input(true);
  public readonly formErrors = input<any>(null);
  public readonly icon = input(true);
  public readonly controlName = input<string>(undefined!);
  public readonly autoPrependWithPlus = input(false);
  public readonly editClicked = output<boolean>();

  private readonly settingsService = inject(SettingsService);
  private readonly msisdnInputIdService = inject(MsisdnInputIdService);

  protected readonly settings = this.settingsService.settings;

  public readonly wrapperId = signal<string | null>(null);

  protected id: string;
  protected controlUID: number;

  constructor() {
    const { inputId, wrapperId, controlUIDCounter } = this.msisdnInputIdService.getMsisdnInputIds();
    this.id = inputId;
    this.wrapperId.set(wrapperId);
    this.controlUID = controlUIDCounter;
  }
}
